export default __webpack_public_path__ + "static/media/warp_speed.3c2a05eb.jpg";